function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Checkbox, Text, PropertyGrid } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { FotaItemMultiSelector } from "../fotaItemMultiSelector/FotaItemMultiSelector.js";
function getListItemContents({
  item,
  valueItem,
  selected,
  onSelect,
  editorProps,
  attr
}) {
  return /*#__PURE__*/React.createElement(PropertyGrid, null, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: Attributes.get('name', attr?.source?.targetType, item, {
      getImagineName: true
    })
  }, /*#__PURE__*/React.createElement(Checkbox, {
    eventData: editorProps.toItemValue(item),
    value: selected,
    onChange: onSelect
  })));
}
function DeviceGroupsSelector(props) {
  const {
    displayOnly,
    attr,
    data
  } = props;
  const value = attr.get(data);
  if (displayOnly) {
    return /*#__PURE__*/React.createElement(Text, null, "You have selected ", value?.length || 0, " device group", value?.length !== 1 ? 's' : '', " to release to.");
  }
  return /*#__PURE__*/React.createElement(FotaItemMultiSelector, _extends({}, props, {
    getListItemContents: getListItemContents
  }));
}
const type = 'deviceGroups';
export default {
  type,
  editor: DeviceGroupsSelector
};